import * as UI from "@accurx/design";
import { TemplateItem } from "domains/message-component/types";

export type TemplateTypes = "Templates" | "Questionnaires" | "Pathways";

/** The metadata for each template type across the application */
type TemplateMetaData = {
    /** The text visible on the filter selection menu when this specific template is applied as the filter */
    selectedFilterLabel: string;
    /** The icon to display when listing templates */
    icon: UI.IconNameVariants;
    /** The text to display when listing templates */
    label: string;
    /** The type of template when combined from the APIs */
    type: TemplateItem["type"] | undefined;
};

export const TEMPLATE_METADATA: Record<TemplateTypes, TemplateMetaData> = {
    Questionnaires: {
        selectedFilterLabel: "Questionnaires",
        icon: "Questionnaire",
        label: "Questionnaire",
        type: "QuestionnaireTemplate",
    },
    Templates: {
        selectedFilterLabel: "Templates",
        icon: "MessageWrite",
        label: "Template",
        type: "MessageTemplate",
    },
    Pathways: {
        selectedFilterLabel: "Pathways",
        icon: "Messages",
        label: "Pathway",
        type: "PathwayTemplate",
    },
};

export type TemplatesFilter = "All" | TemplateTypes;

export const TEMPLATE_FILTER_METADATA: Record<
    TemplatesFilter,
    TemplateMetaData
> = {
    All: {
        selectedFilterLabel: "Filter",
        icon: "Filter",
        label: "Filter",
        type: undefined,
    },
    ...TEMPLATE_METADATA,
};

export const TEMPLATE_TYPES: TemplateTypes[] = Object.keys(
    TEMPLATE_METADATA,
).filter((key) => key !== "All") as TemplateTypes[];
